import { useCallback, useEffect, useRef, useState } from 'react';

/** 載入資料的小工具：回傳 { data, error, loading, reload, setData } */
export default function useLoad(loader, deps = []) {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  const seq = useRef(0);
  // loader 每次 render 都是新函式，用 ref 取最新版本；是否重新載入由 deps 決定
  const loaderRef = useRef(loader);
  loaderRef.current = loader;

  const reload = useCallback(() => {
    const mine = ++seq.current;
    setState((s) => ({ ...s, loading: true, error: null }));
    loaderRef.current()
      .then((data) => { if (mine === seq.current) setState({ data, error: null, loading: false }); })
      .catch((error) => { if (mine === seq.current) setState({ data: null, error, loading: false }); });
  }, []);

  const depsKey = JSON.stringify(deps);
  useEffect(() => { reload(); return () => { seq.current++; }; }, [reload, depsKey]);

  const setData = useCallback((updater) => setState((s) => ({ ...s, data: typeof updater === 'function' ? updater(s.data) : updater })), []);
  return { ...state, reload, setData };
}
